import { IDataTableColumn } from '../DataTable/DataTable';
import { AIUnitWorkspaceColumns } from './AIUnitWorkspacePage.utils';

export const aiUnitWorkspaceColumns: IDataTableColumn[] = [
  {
    key: AIUnitWorkspaceColumns.Workspace,
    fieldName: AIUnitWorkspaceColumns.Workspace,
    name: 'Workspace',
    minWidth: 400,
    isResizable: true,
  },
  {
    key: AIUnitWorkspaceColumns.Namespace,
    fieldName: AIUnitWorkspaceColumns.Namespace,
    name: 'Namespace',
    minWidth: 250,
    isResizable: true,
  },
  {
    key: AIUnitWorkspaceColumns.Pod,
    fieldName: AIUnitWorkspaceColumns.Pod,
    name: 'Pod',
    minWidth: 480,
    maxWidth: 500,
    isResizable: true,
  },
  {
    key: AIUnitWorkspaceColumns.AIUnit,
    fieldName: AIUnitWorkspaceColumns.AIUnit,
    name: 'AI Units',
    minWidth: 110,
    isResizable: true,
  },
  {
    key: AIUnitWorkspaceColumns.Username,
    fieldName: AIUnitWorkspaceColumns.Username,
    name: 'Username',
    minWidth: 150,
    isResizable: true,
  },
];
